module.exports = __webpack_public_path__ + "img/grid-bg.59dfe9c5.png";